import * as Yup from 'yup';
import { StepMainFacilityForm } from '../step-main-facility/step-main-facility-types';

export const stepMergingFacilitySchema = () =>
  Yup.object<StepMainFacilityForm>().shape({
    mergingFacility: Yup.mixed().nullable().required('Povinné pole'),
  });
